import type { FunctionComponent } from 'react';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import logo from '../../../assets/logo/logo--full-vertical.svg';
import { config } from '../../../config/config';
import './crab-landing-page.scss';
import { useSetCookieFromParams } from '../../registration/hooks/use-set-cookie-from-params';
import { Button, ButtonSize, Rounding } from '../../shared/components/button/button';
import { FormattedMessage } from '../../shared/components/formatted-message/formatted-message';
import { ImageLogo } from '../../shared/components/image-logo/image-logo.';
import { Loader } from '../../shared/components/loader/loader';
import { useDesktop } from '../../shared/hooks/breakpoint';

export interface CrabLandingPageInterface {
    className?: string;
    // name?: string | null;
}
interface CrabDataItem {
    crab_landing_image_partner: { filename_disk: string };
    crab_landing_background: { filename_disk: string };
    crab_landing_small_background: { filename_disk: string };
    crab_landing_title: string;
    crab_landing_header: string;
    crab_landing_url_param: string;
    crab_landing_image_crab: { filename_disk: string };
    crab_landing_image_text: { filename_disk: string };
}
interface LandingData {
    crab_landing_image_partner: { filename_disk: string };
    crab_landing_background: { filename_disk: string };
    crab_landing_small_background: { filename_disk: string };
    crab_landing_title: string;
    crab_landing_header: string;
    crab_landing_url_param: string;
    crab_landing_image_crab: { filename_disk: string };
    crab_landing_image_text: { filename_disk: string };
}

const UTM_PAYLOAD_STORAGE_KEY = 'utm_payload';
const UTM_SOURCE_STORAGE_KEY = 'utm_source';

export const CrabLandingPage: FunctionComponent<CrabLandingPageInterface> = () => {
    const { name } = useParams();
    const [crabData, setCrabData] = useState<CrabDataItem[]>([]);
    const [landingData, setLandingData] = useState<LandingData>({
        crab_landing_background: { filename_disk: '' },
        crab_landing_small_background: { filename_disk: '' },
        crab_landing_header: '',
        crab_landing_image_crab: { filename_disk: '' },
        crab_landing_image_partner: { filename_disk: '' },
        crab_landing_image_text: { filename_disk: '' },
        crab_landing_title: '',
        crab_landing_url_param: '',
    });
    const isFullDisplay = useDesktop();
    const token = config.FETCH_DIRECTUS_TOKEN;
    const url = config.FETCH_DIRECTUS_LANDING_ENDPOINT;
    useSetCookieFromParams(UTM_PAYLOAD_STORAGE_KEY);
    useSetCookieFromParams(UTM_SOURCE_STORAGE_KEY);
    const fetchDirectusData = async () => {
        const response = await fetch(url, {
            headers: {
                Authorization: token,
            },
        });

        const json = await response.json();
        return json.data;
    };

    useEffect(() => {
        const fetchData = async () => {
            const result = await fetchDirectusData();
            setCrabData(result);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (name && crabData) {
            const foundItem = crabData.find((item) => item?.crab_landing_title === name);
            if (foundItem) {
                setLandingData({
                    ...landingData,
                    crab_landing_image_partner: {
                        filename_disk: foundItem.crab_landing_image_partner?.filename_disk ?? '',
                    },
                    crab_landing_background: {
                        filename_disk: foundItem.crab_landing_background?.filename_disk ?? '',
                    },
                    crab_landing_small_background: {
                        filename_disk: foundItem.crab_landing_small_background?.filename_disk ?? '',
                    },
                    crab_landing_title: foundItem.crab_landing_title ?? '',
                    crab_landing_url_param: foundItem.crab_landing_url_param ?? '',
                    crab_landing_header: foundItem.crab_landing_header ?? '',
                    crab_landing_image_crab: {
                        filename_disk: foundItem.crab_landing_image_crab?.filename_disk ?? '',
                    },
                    crab_landing_image_text: {
                        filename_disk: foundItem.crab_landing_image_text?.filename_disk ?? '',
                    },
                });
            }
        }
    }, [crabData]);
    const redirectTo = () => {
        landingData?.crab_landing_url_param
            ? (window.location.href = landingData.crab_landing_url_param)
            : (window.location.href = config.BASE_URL + '/registration');
    };
    if (!landingData.crab_landing_title) {
        return <Loader />;
    }

    return (
        <>
            <div className="container-landing">
                {isFullDisplay ? (
                    landingData?.crab_landing_background?.filename_disk ? (
                        <ImageLogo
                            className="hero-image-image"
                            srcPath={
                                landingData?.crab_landing_background?.filename_disk
                                    ? `${config.ASSET_URL}/${landingData?.crab_landing_background?.filename_disk}`
                                    : logo
                            }
                        />
                    ) : null
                ) : landingData?.crab_landing_small_background?.filename_disk ? (
                    <ImageLogo
                        className="hero-image-image"
                        srcPath={
                            landingData?.crab_landing_small_background?.filename_disk
                                ? `${config.ASSET_URL}/${landingData?.crab_landing_small_background?.filename_disk}`
                                : logo
                        }
                    />
                ) : null}

                <div className="hero-text">
                    <Button
                        className="orange"
                        size={ButtonSize.X_LARGE}
                        hollow
                        rounding={Rounding.BIG}
                        light
                        onClick={redirectTo}
                    >
                        {' '}
                        <FormattedMessage id="landing.page" defaultMessage="SIGN UP NOW" />
                    </Button>
                </div>
            </div>
        </>
    );
};
